import { ChannelLogger, ConsoleLogger, createPlayer, } from '@zattoo/playback-sdk-react-native-zapi';
import { WebAdapterName } from '@zattoo/playback-sdk';
import { getEpg } from '../utils/epg';
export class PlayerManager {
    static instance = new PlayerManager();
    static playerPromise = null;
    static publicId = null;
    static lineupHash = null;
    player = null;
    static setPublicId(publicId) {
        this.publicId = publicId;
    }
    static setLineupHash(lineupHash) {
        this.lineupHash = lineupHash;
    }
    static async initializePlayer() {
        if (this.instance.player) {
            return;
        }
        if (!this.publicId || !this.lineupHash) {
            throw new Error('publicId or lineupHash is not set');
        }
        if (this.playerPromise) {
            await this.playerPromise;
            return;
        }
        const consoleLogger = new ConsoleLogger();
        const playerLogger = new ChannelLogger('PlaybackSDK::Player', consoleLogger);
        const adapterLogger = new ChannelLogger('PlaybackSDK::Adapter', consoleLogger);
        const validatedAdapterName = process.env.PLAYER_ADAPTER === WebAdapterName.Bitmovin
            ? WebAdapterName.Bitmovin
            : WebAdapterName.Shaka;
        const playerOptions = {
            host: 'https://staging.zattoo.com',
            publicId: this.publicId,
            appVersion: '9.9.9',
            appId: 204,
            appName: '',
            license: '',
            stepBackwardDuration: 10,
            stepForwardDuration: 10,
            logging: {
                playerLogger,
                adapterLogger,
            },
            latencyMeasurementInterval: 20,
            enableEventDispatcher: true,
            enableMediaSession: true,
            playerAdapter: validatedAdapterName,
        };
        this.playerPromise = createPlayer(playerOptions);
        try {
            const result = await this.playerPromise;
            this.instance.player = result;
            result.setProgramInfoCallback(async (cid, timestamp) => {
                if (!this.lineupHash) {
                    throw new Error('lineupHash is not set');
                }
                const epg = await getEpg(this.lineupHash, [cid]);
                const program = epg?.channels?.[cid]?.find((item) => {
                    return item.s <= timestamp && item.e >= timestamp;
                });
                if (!program) {
                    throw new Error(`No program found for channel ${cid} at timestamp ${timestamp}`);
                }
                return {
                    programId: program.id,
                    start: program.s,
                    duration: program.e - program.s,
                };
            });
        }
        catch (error) {
            this.playerPromise = null;
            throw error;
        }
    }
    static getInstance() {
        if (!this.instance.player) {
            throw new Error('Player not initialized. Call initializePlayer() first.');
        }
        return this.instance;
    }
    getPlayer() {
        return this.player;
    }
}
